import React, { useEffect, useState } from 'react';
import Layout from '../../Layout/Layout';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getcms1, updatecms1 } from '../../actions/users';
import { toast } from 'react-toastify';
import { isEmpty } from '../../actions/commonFunction';

const CmsEdit = () => {


    const navigate = useNavigate();
    const dispatch = useDispatch();


    const [validateError, setValidateError] = useState({});
  const [answer, setanswer] = useState("");
  const [question, setquestion] = useState("");
  

  const { Id } = useParams();
   

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let reqData = {
        question,
        answer,
        Id
    }
    let { error } = await updatecms1(reqData);
    if (isEmpty(error)) {
     toast.success('CMS updated successfully', 1000);
      navigate('/cmslist')
    } else {
      setValidateError(error);
    }
  }
  
  const getFaqData = async () => {
    var test = await getcms1(Id);
    if(test&&test.userValue){
      if(test.userValue.question){
        setquestion(test.userValue.question)
  }
    if(test.userValue.answer){
      setanswer(test.userValue.answer)
  }
    }
  }
  const onEditorChange = (evt) => {
    var description_text = evt; 
    if(description_text == ''){
      setanswer(' ')
    }
    else{
      if(description_text[0]==' '){
        setanswer(description_text.substring(1))
      }
      else{
        setanswer(description_text)
      }
    }
  }

  useEffect(() => {
    //logout(history)
    getFaqData();
  }, [])

    return (
        <Layout>
            <div className="cmsedit">
                <Link to="/cmslist" className="btn sitebtn mb-4">Back</Link>
                <h1 className="pagehead">Edit CMS</h1>
                <div className="cardbox">
                    {
                        answer
                        ?
                        <SunEditor
                                setOptions={{
                                    height: 200,
                                    buttonList: [
                                        // Include the font color button in the toolbar
                                        // ['bold', 'italic', 'underline', 'fontColor', 'fontSize', 'formatBlock'],
                                        [
                                            'undo', 'redo', // Default undo/redo buttons
                                            'bold', 'italic', 'underline', 'strike', // Text styling
                                            'fontColor', 'hiliteColor', // Font and highlight color
                                            'align', 'list', // Alignment and lists
                                            'formatBlock', 'fontSize', // Formatting
                                            'link', 'image', 'video', // Media
                                          ],
                                    ],
                                }}
                            height={300}
                            defaultValue={answer}
                            onChange={onEditorChange}
                        />
                        :
                        <></>
                    }

                    {
                        validateError.answer && <span className='text-danger'>{validateError.answer}</span>
                    }
                    
                    <button type="button" className="btn sitebtn py-2 px-3 mt-4" onClick={handleFormSubmit}>Update</button>
                </div>
            </div>
        </Layout>
    )
}

export default CmsEdit;